import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import type { OnboardingMachineArgs } from '../../utils/state-machine/machine';
import createOnboardingMachine from '../../utils/state-machine/machine';
type OnboardingMachineProviderArgs = {
  args: OnboardingMachineArgs;
};
const useLocalOnboardingRequirementsMachine = t0 => {
  const $ = _c(2);
  const {
    args
  } = t0;
  let t1;
  if ($[0] !== args) {
    t1 = () => createOnboardingMachine(args);
    $[0] = args;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMachine(t1);
};
export const [OnboardingMachineProvider, useOnboardingMachine] = constate(useLocalOnboardingRequirementsMachine);
export default OnboardingMachineProvider;